import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

import { BarChartComponent } from '../../shared/components/bar-chart/bar-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { IReportFilter } from '../../utils/interfaces/report-filter';

@Component({
  selector: 'app-engagement-report-body',
  standalone: true,
  imports: [CommonModule, PrintFilterDataComponent, BarChartComponent],
  templateUrl: '../../main/report/report-data/engagement/engagement.component.html',
})
export class EngagementReportBodyComponent {
  @Input() print = false;
  @Input() filter: IReportFilter | null = null;
  @Input() data: ChartConfiguration<'bar'>['data'] | null = null;
}
